export enum Langs {
  AR = 'ar',
  EN = 'en',
  FR = 'fr',
  TR = 'tr'
}
